import ContentBox from '@shared/ContentBox'
import UpdateEmployeeForm from 'pages/Orders/SalaryCardOrder/feature/SalaryCardOrderForm/UpdateEmployeeForm'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams, useHistory } from 'react-router-dom'
import { useFetchOrderDetailsMutation } from 'store/reducers/salaryCards/orderDetails.api'
import { tabsItems } from './constants/tabsItems.constant'

export default function UpdateSalaryCardOrder() {
  const { t } = useTranslation()
  const orderNo = useParams<{ orderNo: string }>()?.id

  const history = useHistory()
  function handleClick() {
    history.push('/orders/salary-card')
  }

  const [fetchOrderDetail, { isLoading, isError, isSuccess }] =
    useFetchOrderDetailsMutation({
      fixedCacheKey: 'fetchOrderDetails',
    })

  useEffect(() => {
    fetchOrderDetail({ orderNo })
  }, [fetchOrderDetail])

  return (
    <ContentBox
      activeKey="item-3"
      items={[...tabsItems(), { label: t('transfers.edit'), key: 'item-3', path: '/orders/salary-card/update' },]}
      isLoading={isLoading}
      isError={isError}
      handleClick={handleClick}
      title={t('orders.newOrderscards')}
    >
      {isSuccess && <UpdateEmployeeForm />}
    </ContentBox>
  )
}
